// API域名配置
// 在Vue CLI项目中，process.env会被自动注入和替换
// 直接使用process.env，Vue CLI会在构建时处理
const API_DOMAINS = {
  im: process.env.VUE_APP_API_DOMAIN_IM,
  common: process.env.VUE_APP_API_DOMAIN_COMMON,
  seller: process.env.VUE_APP_API_DOMAIN_SELLER,
  manager: process.env.VUE_APP_API_DOMAIN_MANAGER,
  tran: process.env.VUE_APP_API_DOMAIN_TRAN,
  uploadUrl: process.env.VUE_APP_API_DOMAIN_COMMON + '/common/upload/file',
  complaintUploadUrl: process.env.VUE_APP_BASE_API + '/complaint/upload-evidence'
}

export default API_DOMAINS